<div class="card card-non"
  [class.valid]="question.isValid"
  [class.warning]="question.wrongAlternative || question.hasWrongAlternative"
  >
  <label [attr.for]="question.id" class="card-header" [innerHTML]="question.title"></label>
  <div class="card-block mb-4" >
    <div class="form-group">
      @if (question.body) {
        <p [innerHTML]="question.body"></p>
      }
      <app-form-question-control
        [form]="form"
        [readonly]="readonly"
      [question]="question"></app-form-question-control>
    </div>
  </div>
</div>
